"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const common_1 = require("@Const/common");
const publishers_counter_1 = require("@App/helpers/publishers-counter");
const contexts_1 = require("@App/contexts");
const clsx_1 = __importDefault(require("clsx"));
const WorkRegistrationWizardRoad = (props) => {
    const { workStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { currentStep, onlyOneStep } = props;
    const workDraft = workStore.workDraftLocal;
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)(`wizard-road-component current-step-${currentStep}`, onlyOneStep && 'only-one') },
        react_1.default.createElement("div", { className: "wizard-step step-details" },
            react_1.default.createElement("img", { src: common_1.ICONS.workDetails, alt: "Details" }),
            react_1.default.createElement("span", null, "Details")),
        react_1.default.createElement("div", { className: "wizard-step step-writers" },
            react_1.default.createElement("img", { src: common_1.ICONS.writers, alt: "Writers" }),
            react_1.default.createElement("span", { "data-count": `(${workDraft ? workDraft.writers.length : 0})` }, "Writers")),
        react_1.default.createElement("div", { className: "wizard-step step-details" },
            react_1.default.createElement("img", { src: common_1.ICONS.publishers, alt: "Publishers" }),
            react_1.default.createElement("span", { "data-count": `(${workDraft ? (0, publishers_counter_1.publishersCounter)(workDraft.originalPublishers) : 0})` }, "Publishers")),
        react_1.default.createElement("div", { className: "wizard-step step-details" },
            react_1.default.createElement("img", { src: common_1.ICONS.recording, alt: "Recordings" }),
            react_1.default.createElement("span", { "data-count": `(${workDraft ? workDraft.recordings.length : 0})` }, "Recordings")),
        react_1.default.createElement("div", { className: "wizard-step step-details" },
            react_1.default.createElement("img", { src: common_1.ICONS.review, alt: "Review" }),
            react_1.default.createElement("span", null, "Review"))));
};
exports.default = WorkRegistrationWizardRoad;
